export function domainStatus (prop, t$) {
  const icons = {
    true: '$symbols-circle-check-filled',
    false: '$symbols-alert-filled'
  }

  const color = {
    true: 'success',
    false: '#F43339'
  }

  const status = {
    true: true,
    false: false
  }

  return {
    value: t$[prop],
    icons: icons[prop],
    color: color[prop],
    status: status[prop]
  }
}
